module.exports = __webpack_public_path__ + "img/E_TalkBeforeAction.8aaa8dcd.gif";